export const siteSettings = {
  name: "Trade Nexus",
  link: "https://tradesnexus.live",
  email: "support@tradesnexus.live",
  appLink: "https://app.tradesnexus.live",
};
